var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _circle117, _circle118, _circle119, _circle120, _circle121, _circle122, _circle123, _circle124, _circle125, _circle126, _circle127, _circle128, _circle129, _circle130, _circle131, _circle132, _circle133, _circle134, _circle135, _circle136, _circle137, _circle138, _circle139, _circle140, _circle141, _circle142, _circle143, _circle144, _circle145, _circle146, _circle147, _circle148, _circle149, _circle150, _circle151, _circle152, _circle153, _circle154, _circle155, _circle156, _circle157, _circle158, _circle159, _circle160, _circle161, _circle162, _circle163, _circle164, _circle165, _circle166, _circle167, _circle168, _circle169, _circle170, _circle171, _circle172, _circle173, _circle174, _circle175, _circle176, _circle177, _circle178, _circle179, _circle180, _circle181, _circle182, _circle183, _circle184, _circle185, _circle186, _circle187, _circle188, _circle189, _circle190, _circle191, _circle192, _circle193, _circle194, _circle195, _circle196, _circle197, _circle198, _circle199, _circle200, _circle201, _circle202, _circle203, _circle204, _circle205, _circle206, _circle207, _circle208, _circle209, _circle210, _circle211, _circle212, _circle213, _circle214, _circle215, _circle216, _circle217, _circle218, _circle219, _circle220, _rect, _circle221, _circle222, _path, _circle223, _path2, _circle224, _path3, _path4, _circle225, _polygon, _polygon2, _polygon3, _path5, _path6, _path7, _path8, _path9, _polygon4, _polygon5, _polygon6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNextjs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 888,
    height: 442.24956,
    viewBox: "0 0 888 442.24956",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "next_js") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 190.00923,
    cy: 79.90411,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 218.10149,
    cy: 79.90411,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.19376,
    cy: 79.90411,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.28602,
    cy: 79.90411,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 302.37828,
    cy: 79.90411,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 330.47054,
    cy: 79.90411,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.5628,
    cy: 79.90411,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 386.65506,
    cy: 79.90411,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 414.74732,
    cy: 79.90411,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.83958,
    cy: 79.90411,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 470.93185,
    cy: 79.90411,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.02411,
    cy: 79.90411,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.11637,
    cy: 79.90411,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.20863,
    cy: 79.90411,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 583.30089,
    cy: 79.90411,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 611.39315,
    cy: 79.90411,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 639.48541,
    cy: 79.90411,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 667.57767,
    cy: 79.90411,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 695.66993,
    cy: 79.90411,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 723.7622,
    cy: 79.90411,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 751.85446,
    cy: 79.90411,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 779.94672,
    cy: 79.90411,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.00923,
    cy: 108.34899,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 218.10149,
    cy: 108.34899,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.19376,
    cy: 108.34899,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.28602,
    cy: 108.34899,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 302.37828,
    cy: 108.34899,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 330.47054,
    cy: 108.34899,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.5628,
    cy: 108.34899,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 386.65506,
    cy: 108.34899,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 414.74732,
    cy: 108.34899,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.83958,
    cy: 108.34899,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 470.93185,
    cy: 108.34899,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.02411,
    cy: 108.34899,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.11637,
    cy: 108.34899,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.20863,
    cy: 108.34899,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 583.30089,
    cy: 108.34899,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 611.39315,
    cy: 108.34899,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 639.48541,
    cy: 108.34899,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 667.57767,
    cy: 108.34899,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 695.66993,
    cy: 108.34899,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 723.7622,
    cy: 108.34899,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 751.85446,
    cy: 108.34899,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 779.94672,
    cy: 108.34899,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.00923,
    cy: 136.79387,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 218.10149,
    cy: 136.79387,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.19376,
    cy: 136.79387,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.28602,
    cy: 136.79387,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 302.37828,
    cy: 136.79387,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 330.47054,
    cy: 136.79387,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.5628,
    cy: 136.79387,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 386.65506,
    cy: 136.79387,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 414.74732,
    cy: 136.79387,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.83958,
    cy: 136.79387,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 470.93185,
    cy: 136.79387,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.02411,
    cy: 136.79387,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.11637,
    cy: 136.79387,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.20863,
    cy: 136.79387,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 583.30089,
    cy: 136.79387,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 611.39315,
    cy: 136.79387,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 639.48541,
    cy: 136.79387,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 667.57767,
    cy: 136.79387,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 695.66993,
    cy: 136.79387,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 723.7622,
    cy: 136.79387,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 751.85446,
    cy: 136.79387,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 779.94672,
    cy: 136.79387,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.00923,
    cy: 165.23874,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 218.10149,
    cy: 165.23874,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.19376,
    cy: 165.23874,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.28602,
    cy: 165.23874,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 302.37828,
    cy: 165.23874,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 330.47054,
    cy: 165.23874,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.5628,
    cy: 165.23874,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 386.65506,
    cy: 165.23874,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 414.74732,
    cy: 165.23874,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.83958,
    cy: 165.23874,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 470.93185,
    cy: 165.23874,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.02411,
    cy: 165.23874,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.11637,
    cy: 165.23874,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.20863,
    cy: 165.23874,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 583.30089,
    cy: 165.23874,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 611.39315,
    cy: 165.23874,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 639.48541,
    cy: 165.23874,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 667.57767,
    cy: 165.23874,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 695.66993,
    cy: 165.23874,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 723.7622,
    cy: 165.23874,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 751.85446,
    cy: 165.23874,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 779.94672,
    cy: 165.23874,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.00923,
    cy: 193.68362,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 218.10149,
    cy: 193.68362,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.19376,
    cy: 193.68362,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.28602,
    cy: 193.68362,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 302.37828,
    cy: 193.68362,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 330.47054,
    cy: 193.68362,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.5628,
    cy: 193.68362,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 386.65506,
    cy: 193.68362,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 414.74732,
    cy: 193.68362,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.83958,
    cy: 193.68362,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 470.93185,
    cy: 193.68362,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.02411,
    cy: 193.68362,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.11637,
    cy: 193.68362,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.20863,
    cy: 193.68362,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: 583.30089,
    cy: 193.68362,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: 611.39315,
    cy: 193.68362,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    cx: 639.48541,
    cy: 193.68362,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    cx: 667.57767,
    cy: 193.68362,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: 695.66993,
    cy: 193.68362,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    cx: 723.7622,
    cy: 193.68362,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    cx: 751.85446,
    cy: 193.68362,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    cx: 779.94672,
    cy: 193.68362,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.00923,
    cy: 222.1285,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    cx: 218.10149,
    cy: 222.1285,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.19376,
    cy: 222.1285,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.28602,
    cy: 222.1285,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    cx: 302.37828,
    cy: 222.1285,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    cx: 330.47054,
    cy: 222.1285,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.5628,
    cy: 222.1285,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    cx: 386.65506,
    cy: 222.1285,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    cx: 414.74732,
    cy: 222.1285,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.83958,
    cy: 222.1285,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    cx: 470.93185,
    cy: 222.1285,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.02411,
    cy: 222.1285,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.11637,
    cy: 222.1285,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.20863,
    cy: 222.1285,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    cx: 583.30089,
    cy: 222.1285,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    cx: 611.39315,
    cy: 222.1285,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    cx: 639.48541,
    cy: 222.1285,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    cx: 667.57767,
    cy: 222.1285,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    cx: 695.66993,
    cy: 222.1285,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    cx: 723.7622,
    cy: 222.1285,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    cx: 751.85446,
    cy: 222.1285,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    cx: 779.94672,
    cy: 222.1285,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.00923,
    cy: 250.57337,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    cx: 218.10149,
    cy: 250.57337,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.19376,
    cy: 250.57337,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.28602,
    cy: 250.57337,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    cx: 302.37828,
    cy: 250.57337,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    cx: 330.47054,
    cy: 250.57337,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.5628,
    cy: 250.57337,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    cx: 386.65506,
    cy: 250.57337,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    cx: 414.74732,
    cy: 250.57337,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.83958,
    cy: 250.57337,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    cx: 470.93185,
    cy: 250.57337,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.02411,
    cy: 250.57337,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.11637,
    cy: 250.57337,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.20863,
    cy: 250.57337,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    cx: 583.30089,
    cy: 250.57337,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    cx: 611.39315,
    cy: 250.57337,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    cx: 639.48541,
    cy: 250.57337,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    cx: 667.57767,
    cy: 250.57337,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle151 || (_circle151 = /*#__PURE__*/React.createElement("circle", {
    cx: 695.66993,
    cy: 250.57337,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle152 || (_circle152 = /*#__PURE__*/React.createElement("circle", {
    cx: 723.7622,
    cy: 250.57337,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle153 || (_circle153 = /*#__PURE__*/React.createElement("circle", {
    cx: 751.85446,
    cy: 250.57337,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle154 || (_circle154 = /*#__PURE__*/React.createElement("circle", {
    cx: 779.94672,
    cy: 250.57337,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle155 || (_circle155 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.00923,
    cy: 279.01825,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle156 || (_circle156 = /*#__PURE__*/React.createElement("circle", {
    cx: 218.10149,
    cy: 279.01825,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle157 || (_circle157 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.19376,
    cy: 279.01825,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle158 || (_circle158 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.28602,
    cy: 279.01825,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle159 || (_circle159 = /*#__PURE__*/React.createElement("circle", {
    cx: 302.37828,
    cy: 279.01825,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle160 || (_circle160 = /*#__PURE__*/React.createElement("circle", {
    cx: 330.47054,
    cy: 279.01825,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle161 || (_circle161 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.5628,
    cy: 279.01825,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle162 || (_circle162 = /*#__PURE__*/React.createElement("circle", {
    cx: 386.65506,
    cy: 279.01825,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle163 || (_circle163 = /*#__PURE__*/React.createElement("circle", {
    cx: 414.74732,
    cy: 279.01825,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle164 || (_circle164 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.83958,
    cy: 279.01825,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle165 || (_circle165 = /*#__PURE__*/React.createElement("circle", {
    cx: 470.93185,
    cy: 279.01825,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle166 || (_circle166 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.02411,
    cy: 279.01825,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle167 || (_circle167 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.11637,
    cy: 279.01825,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle168 || (_circle168 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.20863,
    cy: 279.01825,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle169 || (_circle169 = /*#__PURE__*/React.createElement("circle", {
    cx: 583.30089,
    cy: 279.01825,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle170 || (_circle170 = /*#__PURE__*/React.createElement("circle", {
    cx: 611.39315,
    cy: 279.01825,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle171 || (_circle171 = /*#__PURE__*/React.createElement("circle", {
    cx: 639.48541,
    cy: 279.01825,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle172 || (_circle172 = /*#__PURE__*/React.createElement("circle", {
    cx: 667.57767,
    cy: 279.01825,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle173 || (_circle173 = /*#__PURE__*/React.createElement("circle", {
    cx: 695.66993,
    cy: 279.01825,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle174 || (_circle174 = /*#__PURE__*/React.createElement("circle", {
    cx: 723.7622,
    cy: 279.01825,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle175 || (_circle175 = /*#__PURE__*/React.createElement("circle", {
    cx: 751.85446,
    cy: 279.01825,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle176 || (_circle176 = /*#__PURE__*/React.createElement("circle", {
    cx: 779.94672,
    cy: 279.01825,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle177 || (_circle177 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.00923,
    cy: 307.46313,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle178 || (_circle178 = /*#__PURE__*/React.createElement("circle", {
    cx: 218.10149,
    cy: 307.46313,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle179 || (_circle179 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.19376,
    cy: 307.46313,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle180 || (_circle180 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.28602,
    cy: 307.46313,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle181 || (_circle181 = /*#__PURE__*/React.createElement("circle", {
    cx: 302.37828,
    cy: 307.46313,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle182 || (_circle182 = /*#__PURE__*/React.createElement("circle", {
    cx: 330.47054,
    cy: 307.46313,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle183 || (_circle183 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.5628,
    cy: 307.46313,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle184 || (_circle184 = /*#__PURE__*/React.createElement("circle", {
    cx: 386.65506,
    cy: 307.46313,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle185 || (_circle185 = /*#__PURE__*/React.createElement("circle", {
    cx: 414.74732,
    cy: 307.46313,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle186 || (_circle186 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.83958,
    cy: 307.46313,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle187 || (_circle187 = /*#__PURE__*/React.createElement("circle", {
    cx: 470.93185,
    cy: 307.46313,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle188 || (_circle188 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.02411,
    cy: 307.46313,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle189 || (_circle189 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.11637,
    cy: 307.46313,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle190 || (_circle190 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.20863,
    cy: 307.46313,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle191 || (_circle191 = /*#__PURE__*/React.createElement("circle", {
    cx: 583.30089,
    cy: 307.46313,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle192 || (_circle192 = /*#__PURE__*/React.createElement("circle", {
    cx: 611.39315,
    cy: 307.46313,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle193 || (_circle193 = /*#__PURE__*/React.createElement("circle", {
    cx: 639.48541,
    cy: 307.46313,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle194 || (_circle194 = /*#__PURE__*/React.createElement("circle", {
    cx: 667.57767,
    cy: 307.46313,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle195 || (_circle195 = /*#__PURE__*/React.createElement("circle", {
    cx: 695.66993,
    cy: 307.46313,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle196 || (_circle196 = /*#__PURE__*/React.createElement("circle", {
    cx: 723.7622,
    cy: 307.46313,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle197 || (_circle197 = /*#__PURE__*/React.createElement("circle", {
    cx: 751.85446,
    cy: 307.46313,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle198 || (_circle198 = /*#__PURE__*/React.createElement("circle", {
    cx: 779.94672,
    cy: 307.46313,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle199 || (_circle199 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.00923,
    cy: 335.908,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle200 || (_circle200 = /*#__PURE__*/React.createElement("circle", {
    cx: 218.10149,
    cy: 335.908,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle201 || (_circle201 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.19376,
    cy: 335.908,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle202 || (_circle202 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.28602,
    cy: 335.908,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle203 || (_circle203 = /*#__PURE__*/React.createElement("circle", {
    cx: 302.37828,
    cy: 335.908,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle204 || (_circle204 = /*#__PURE__*/React.createElement("circle", {
    cx: 330.47054,
    cy: 335.908,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle205 || (_circle205 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.5628,
    cy: 335.908,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle206 || (_circle206 = /*#__PURE__*/React.createElement("circle", {
    cx: 386.65506,
    cy: 335.908,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle207 || (_circle207 = /*#__PURE__*/React.createElement("circle", {
    cx: 414.74732,
    cy: 335.908,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle208 || (_circle208 = /*#__PURE__*/React.createElement("circle", {
    cx: 442.83958,
    cy: 335.908,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle209 || (_circle209 = /*#__PURE__*/React.createElement("circle", {
    cx: 470.93185,
    cy: 335.908,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle210 || (_circle210 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.02411,
    cy: 335.908,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle211 || (_circle211 = /*#__PURE__*/React.createElement("circle", {
    cx: 527.11637,
    cy: 335.908,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle212 || (_circle212 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.20863,
    cy: 335.908,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle213 || (_circle213 = /*#__PURE__*/React.createElement("circle", {
    cx: 583.30089,
    cy: 335.908,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle214 || (_circle214 = /*#__PURE__*/React.createElement("circle", {
    cx: 611.39315,
    cy: 335.908,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle215 || (_circle215 = /*#__PURE__*/React.createElement("circle", {
    cx: 639.48541,
    cy: 335.908,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle216 || (_circle216 = /*#__PURE__*/React.createElement("circle", {
    cx: 667.57767,
    cy: 335.908,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle217 || (_circle217 = /*#__PURE__*/React.createElement("circle", {
    cx: 695.66993,
    cy: 335.908,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle218 || (_circle218 = /*#__PURE__*/React.createElement("circle", {
    cx: 723.7622,
    cy: 335.908,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle219 || (_circle219 = /*#__PURE__*/React.createElement("circle", {
    cx: 751.85446,
    cy: 335.908,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _circle220 || (_circle220 = /*#__PURE__*/React.createElement("circle", {
    cx: 779.94672,
    cy: 335.908,
    r: 5.54965,
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 341.12316,
    width: 888,
    height: 2.24072
  })), _circle221 || (_circle221 = /*#__PURE__*/React.createElement("circle", {
    cx: 857.37804,
    cy: 271.93466,
    r: 28.89362,
    fill: "#00adb5"
  })), _circle222 || (_circle222 = /*#__PURE__*/React.createElement("circle", {
    cx: 869.39158,
    cy: 309.4043,
    r: 3.67737
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M483.52846,398.70427H598.7473V407.862H494.09019v68.92413h98.41609v9.15775H494.09019v75.672H599.9475v9.15774h-116.419Zm125.54053,0h12.242l54.24887,75.67195,55.44907-75.67195,75.41978-96.12077L682.521,482.329l63.85044,88.44458H733.64936l-58.0895-80.4918-58.32953,80.4918H604.74827L669.0788,482.329ZM750.93216,407.862v-9.15775H882.23365V407.862h-60.4899V570.77359H811.182V407.862Zm-411.54723-9.15775h13.20216L534.63714,671.12478,459.40456,570.77359,350.42674,411.71792l-.48008,159.05567H339.38493ZM881.16952,558.85222a3.833,3.833,0,1,1,3.77622-3.83256A3.73261,3.73261,0,0,1,881.16952,558.85222Zm10.37817-10.083h5.65146c.07708,3.06091,2.312,5.11868,5.60011,5.11868,3.67347,0,5.75421-2.2121,5.75421-6.35335V521.29808h5.75425v26.26219c0,7.45939-4.31569,11.755-11.45708,11.755C896.14594,559.31523,891.54769,555.14826,891.54769,548.76921Zm30.28676-.33439h5.70284c.4881,3.52391,3.93035,5.76173,8.88824,5.76173,4.624,0,8.01483-2.39215,8.01483-5.68457,0-2.82943-2.15783-4.52707-7.06434-5.68456l-4.77809-1.15749c-6.7047-1.56905-9.76161-4.81-9.76161-10.26309,0-6.61056,5.39458-11.009,13.48645-11.009,7.52674,0,13.0241,4.39847,13.358,10.64892h-5.60008c-.53948-3.421-3.51933-5.556-7.835-5.556-4.54688,0-7.57811,2.18636-7.57811,5.53023,0,2.64936,1.95232,4.167,6.78175,5.29873l4.08448,1.00316c7.60381,1.77482,10.7378,4.86146,10.7378,10.44315,0,7.09928-5.49732,11.54918-14.28281,11.54918C927.7685,559.31523,922.24547,555.07109,921.83445,548.43482Z",
    transform: "translate(-156 -228.87522)"
  })), _circle223 || (_circle223 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.864,
    cy: 63.38029,
    r: 10.7783,
    fill: "#00adb5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M278.86687,281.7739a10.77979,10.77979,0,0,1,9.48819,15.89357A10.77573,10.77573,0,1,0,270.452,285.827,10.7517,10.7517,0,0,1,278.86687,281.7739Z",
    transform: "translate(-156 -228.87522)",
    fill: "#00adb5"
  })), _circle224 || (_circle224 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.72319,
    cy: 31.6962,
    r: 31.66125,
    fill: "#00adb5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M230.87426,240.92712a31.65557,31.65557,0,0,1,43.87848-3.31975c-.25891-.24611-.51507-.49421-.78409-.73337A31.66126,31.66126,0,0,0,231.897,284.19961c.269.23916.54542.46449.82017.69278A31.65557,31.65557,0,0,1,230.87426,240.92712Z",
    transform: "translate(-156 -228.87522)",
    fill: "#00adb5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M286.254,341.28137l4.87038,27.59877,5.68209,54.38581s1.62346,21.91667-5.68209,22.7284-5.6821-24.35186-5.6821-24.35186L277.325,375.374l-3.24691-28.41049Z",
    transform: "translate(-156 -228.87522)",
    fill: "#fbbebe"
  })), _circle225 || (_circle225 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.22002,
    cy: 38.53885,
    r: 19.48148,
    fill: "#fbbebe"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "84.797 46.656 81.55 65.326 102.655 70.196 102.655 52.338 84.797 46.656",
    fill: "#fbbebe"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "34.47 319.397 32.035 335.631 41.776 336.443 47.458 322.644 34.47 319.397",
    fill: "#fbbebe"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "109.961 321.832 112.396 334.82 122.948 334.82 122.948 322.644 109.961 321.832",
    fill: "#fbbebe"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M273.26632,368.88014l-53.57409,8.11728-3.24691,38.15124-6.49383,55.19754-23.54013,80.36113,23.54013,2.43518,42.20989-107.95989,10.55247,108.77162H287.0657l1.62346-111.20681s.81173-61.69137-12.17593-65.75Z",
    transform: "translate(-156 -228.87522)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M200.21075,562.88326l-13.79939-2.43519-5.6821,27.59877s-10.55247,37.33951,3.24692,34.0926,11.3642-34.0926,11.3642-34.0926Z",
    transform: "translate(-156 -228.87522)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M265.96076,562.88326l13.79939-2.43519,5.6821,27.59877s10.55247,37.33951-3.24692,34.0926-11.3642-34.0926-11.3642-34.0926Z",
    transform: "translate(-156 -228.87522)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M198.58729,329.10544s-6.49383,34.0926-3.24691,42.20988,21.91667,36.52779,21.91667,36.52779l5.6821-12.17593-16.23457-31.65741,5.6821-32.46915Z",
    transform: "translate(-156 -228.87522)",
    fill: "#fbbebe"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M262.71385,305.56531l-1.62346-12.17593s-20.29321-3.24691-23.54013-8.929l-5.6821,9.74074-18.66975,4.05864s-10.55247,0-11.3642,8.11729-5.6821,24.35186-5.6821,24.35186l14.61111,4.87037,11.3642,42.20988,48.70371-7.30556L268.396,348.58692l2.43518-5.6821,2.43519,6.49383,15.42284-3.24691s.81173-29.22223-14.61111-34.0926Z",
    transform: "translate(-156 -228.87522)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "82.014 17.207 82.014 37.599 86.737 37.599 92.747 31.16 91.942 37.599 112.817 37.599 111.529 31.16 114.105 37.599 117.432 37.599 117.432 17.207 82.014 17.207",
    fill: "#00adb5"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "858.878 343.354 855.878 343.354 857.378 272.354 858.878 343.354"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "858 334.354 856.538 333.23 870.865 306.829 858 334.354"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextjs);
export default __webpack_public_path__ + "static/media/nextjs.bf9180b80550f274d92ba5e739c0f4bd.svg";
export { ForwardRef as ReactComponent };